var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as dayjs from 'dayjs';
import { html, LitElement } from 'lit';
import groupBy from "lodash/groupBy";
import css from './style.pcss';
import translations from '../../common/sport/translations';
import { helper } from "../../common/helper";
import PauseButtonIcon from "../../common/images/btn_pause.svg";
import ReplayButtonIcon from "../../common/images/btn_replay.svg";
import TickerButtonIcon from "../../common/images/btn_ticker.svg";
import LiveButtonIcon from "../../common/images/btn_live.svg";
import LiveTickerButtonIcon from "../../common/images/btn_liveticker.svg";
import LiveArenaButtonIcon from "../../common/images/btn_livearena.svg";
import HighlightsButtonIcon from "../../common/images/btn_highlights.svg";
import PlaceholderLogoImage from "../../common/images/logo_placeholder.svg";
import ArrowDownIcon from "../../common/images/arrow_down.svg";
import LogoWidgetImage from "../../common/images/logo_rtl-live-arena-gr_dark.svg";
import ApartLogo from "../../common/images/aparttv_btn.svg";
import GoldLiveButtonIcon from "../../common/images/btn_live_gold.svg";
import GoldLiveArenaButtonIcon from "../../common/images/btn_livearena_gold.svg";
import GoldReplayButtonIcon from "../../common/images/btn_replay_gold.svg";
import FootballIcon from "./images/1.svg";
import BasketballIcon from "./images/2.svg";
import HandballIcon from "./images/3.svg";
import VolleyballIcon from "./images/4.svg";
import TabletennisIcon from "./images/5.svg";
var SportIcons = {
  1: FootballIcon,
  2: BasketballIcon,
  3: HandballIcon,
  4: VolleyballIcon,
  5: TabletennisIcon
};
var openedCompetitions = [305,
// BGL
306 // eirepromotioun
];
var RTLSportHighlights = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportHighlights, _LitElement);
  function RTLSportHighlights() {
    var _this;
    _classCallCheck(this, RTLSportHighlights);
    _this = _callSuper(this, RTLSportHighlights);
    _this.view = 'default';
    _this.language = 'lu';
    _this.showLogos = true;
    _this.type = 'large';
    _this.sport = 1; // Football
    _this.link = _this._getLink(1);
    _this.weekend = false;
    _this.links = "internal";
    _this.debug = 0;
    _this.openFirstBox = true;
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 15000);
    _this.types = ['football', 'basketball', 'handball', 'volleyball', 'table-tennis', 'cycling'];
    _this.aparttvMatches = [];
    _this.version = 1;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.version = window.rtlsites.config.version;
    }
    return _this;
  }
  _createClass(RTLSportHighlights, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportHighlights.prototype), "connectedCallback", this).call(this);
      if (this.weekend) {
        var day = dayjs().format('d');
        var now = dayjs().format('HHmm');
        if (day > 0 && day < 5) {
          return;
        } else {
          if (day == 5 && now < 1200 || day == 1 && now > 1200) {
            return;
          }
        }
      }
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var sport_id = "";
      if (this.language !== 'lu') sport_id = '&sport_id=1'; // Comma delimited sport_id=1,2,3
      this._apiUrl = `https://api-gate.rtl.lu/sport/highlights?lang=${this.language}&debug=${this.debug}${sport_id}`;
      var matchDates = [];
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        resp.highlight.forEach(function (highlight) {
          highlight.competitions.forEach(function (comp) {
            if (openedCompetitions.includes(comp.id)) _this2.openFirstBox = false;
            comp.rounds.forEach(function (round) {
              round.matches.forEach(function (match) {
                if (match.date) matchDates.push(match.date);
              });
            });
          });
        });
        _this2.livearena_sports = [1, 2, 3, 4];
        matchDates = _toConsumableArray(new Set(matchDates)); // make unique

        if (matchDates.length > 0) {
          fetch("https://api-gate.rtl.lu/sport/apart-tv?dates=" + matchDates.join(",")).then(function (apartResp) {
            return apartResp.json();
          }).then(function (apartResp) {
            _this2.aparttvMatches = apartResp;
          });
        }

        // console.log("allMatches", this.data.results)
        //console.log(this.data);
      }).catch(function (error) {
        if (this.interval) clearInterval(this.interval);
        console.log('ERROR: ' + error.message);
      }.bind(this));
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getLink",
    value: function _getLink(sportid) {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + sportid)}/resultater`;
      return link;
    }
  }, {
    key: "_showResultsAndTable",
    value: function _showResultsAndTable(e, link) {
      if (this.links === 'external') {
        window.open(link, '_blank');
        return;
      }
      document.location.href = link;
    }
  }, {
    key: "_showHighlight",
    value: function _showHighlight(e, id) {
      this.querySelector('.rtl-sport-hls-competition__container--open').classList.remove('rtl-sport-hls-competition__container--open');
      //console.log('.rtl-sport-hls-competition__container--' + id + '-0');
      this.querySelector('.rtl-sport-hls-competition__container--' + id + '-0').classList.add('rtl-sport-hls-competition__container--open');
      this.querySelector('.rtl-sport-hls-nav__item--active').classList.remove('rtl-sport-hls-nav__item--active');
      e.target.classList.add('rtl-sport-hls-nav__item--active');
      this.querySelector('.rtl-sport-hls-container--visible').classList.toggle('rtl-sport-hls-container--visible');
      this.querySelector('.js-hls-' + id).classList.toggle('rtl-sport-hls-container--visible');
      this.link = this._getLink(id);
    }
  }, {
    key: "_showCompetition",
    value: function _showCompetition(e, key, sportid) {
      this.querySelector('.rtl-sport-hls-competition__container--open').classList.remove('rtl-sport-hls-competition__container--open');
      var container = this.querySelector('.rtl-sport-hls-competition__container--' + sportid + '-' + key);
      container.classList.add('rtl-sport-hls-competition__container--open');
    }

    // TODO: Params cleanup
  }, {
    key: "_showLiveticker",
    value: function _showLiveticker(e, match, has_details, live_arena_id, live_arena_hidden) {
      var summary = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (!has_details && !live_arena_id) return;
      helper.openLivearenaLink(match.id, summary, match.sport.id, match.has_ticker);

      //this.view = 'liveticker';
      //this.matchid = matchid;
    }
  }, {
    key: "_filterMatches",
    value: function _filterMatches(matches) {
      var out = groupBy(matches, function (match) {
        if (match.hour != null) return dayjs(match.date + " " + match.hour).format('DD/MM/YYYY HH:mm');else if (match.date) return dayjs(match.date).format('DD/MM/YYYY');else return this._getTranslation('verluecht');
      }.bind(this));
      return out;
    }
  }, {
    key: "shouldShowApartButton",
    value: function shouldShowApartButton(match) {
      var ret = false;
      this.aparttvMatches.some(function (apart) {
        if (match.home_team.id == apart.home_team && match.visitor_team.id == apart.guest_team && match.date === apart.date && apart.time == match.hour) {
          var date = dayjs(`${apart.date} ${apart.time}`).add(2, 'hour');
          var now = dayjs();
          ret = now.isBefore(date) || match.is_live;
        }
      });
      return ret;
    }
  }, {
    key: "_renderMatches",
    value: function _renderMatches(matches, cid, sid) {
      var _this3 = this;
      var filteredMatches = this._filterMatches(matches);
      var tableRows = [];
      var table;

      //console.log(filteredMatches);
      for (var key in filteredMatches) {
        tableRows.push(html(_t || (_t = _`
                <tr>
                    <th colspan="6" class="results-table__date">${0}</th>
                </tr>
            `), key));
        if (filteredMatches.hasOwnProperty(key)) {
          tableRows.push(filteredMatches[key].map(function (match) {
            var shouldShowApartButton = _this3.shouldShowApartButton(match);
            var isRowClickable = false;
            var icon = null;
            if (match.is_paused) {
              icon = html(_t2 || (_t2 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), PauseButtonIcon);
            } else {
              var isLive = match.is_live;
              var hasTicker = match.has_ticker;
              var wasPlayed = match.was_played;
              var hasId = !match.live_arena_hidden && (match.live_arena_id || match.live_arena_replay_id || match.live_arena_livestream_id);
              var isGold = match.live_arena_top_match;
              if (hasTicker) icon = html(_t3 || (_t3 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), TickerButtonIcon);
              if (hasTicker && isLive) icon = html(_t4 || (_t4 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), LiveTickerButtonIcon);
              if (hasId) icon = html(_t5 || (_t5 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldLiveArenaButtonIcon : LiveArenaButtonIcon);
              if (wasPlayed && hasId) icon = html(_t6 || (_t6 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldReplayButtonIcon : ReplayButtonIcon);
              if (isLive && hasId) icon = html(_t7 || (_t7 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), isGold ? GoldLiveButtonIcon : LiveButtonIcon);
              if (shouldShowApartButton) icon = html(_t8 || (_t8 = _`<img class="results-table__button-more" src="${0}" alt="button more"/>`), ApartLogo);
              if (match.info === "postponed") icon = null;
            }
            isRowClickable = !!icon;
            var iconSummary;
            if (match.live_arena_summary_url) iconSummary = html(_t9 || (_t9 = _`<img class="results-table__button-highlights" src="${0}" alt="button more"/>`), HighlightsButtonIcon);
            var home_logo, visitor_logo;
            if (_this3.livearena_sports.includes(_this3.sport)) {
              home_logo = html(_t10 || (_t10 = _`<td class="results-table__team1-img"><img class="results-table__img" src="${0}" /></td>`), PlaceholderLogoImage);
              visitor_logo = html(_t11 || (_t11 = _`<td class="results-table__team1-img"><img class="results-table__img" src="${0}" /></td>`), PlaceholderLogoImage);
            }
            if (!match.home_team || !match.visitor_team) return null;
            if (match.home_team.logo_url) home_logo = html(_t12 || (_t12 = _`<td class="results-table__team1-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, helper.stockify(match.home_team.logo_url, 64), _this3.version);
            if (match.visitor_team.logo_url) visitor_logo = html(_t13 || (_t13 = _`<td class="results-table__team2-img" @click=${0}><img class="results-table__img" src="${0}?v=${0}" /></td>`), function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, helper.stockify(match.visitor_team.logo_url, 64), _this3.version);
            return html(_t14 || (_t14 = _`
                        <tr class="results-table__match${0}${0}">

                            ${0}
                            <td class="results-table__team1" @click=${0}>
                                ${0}
                            </td>
                            ${0}
                            <td class="results-table__score" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                            ${0}
                            <td class="results-table__team2" @click=${0}>
                                ${0}
                            </td>
                            ${0}
                            ${0}

                        </tr>
                    `), isRowClickable ? ' results-table__match--is-clickable' : '', match.is_live ? ' results-table__match--islive' : '', _this3.type === 'main' ? home_logo : '', function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, _this3.type === 'main' ? html(_t15 || (_t15 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.home_team.name, match.home_team.short_name) : match.home_team.short_name ? match.home_team.short_name : match.home_team.name, _this3.type === 'small' ? home_logo : '', function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, html(_t16 || (_t16 = _`${0} : ${0}`), match.home_score, match.visitor_score), match.info !== 'date_unknown' && match.info ? html(_t17 || (_t17 = _`<span class="results-match__info">${0}</span>`), _this3._getTranslation(match.info + '-' + _this3.sport + '_short')) : '', _this3.type === 'small' ? visitor_logo : '', function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, _this3.type === 'main' ? html(_t18 || (_t18 = _`<span class="results-table__teamname">${0}</span><span class="results-table__shortteamname">${0}</span>`), match.visitor_team.name, match.visitor_team.short_name) : match.visitor_team.short_name ? match.visitor_team.short_name : match.visitor_team.name, _this3.type === 'main' ? visitor_logo : '', icon || iconSummary ? html(_t19 || (_t19 = _`
                                <td class="results-table__button-more-container">
                                    <span @click=${0}>${0}</span>
                                    <span @click=${0}>${0}</span>
                                </td>
                            `), function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden);
            }, icon, function (e) {
              return _this3._showLiveticker(e, match, match.has_details, cid, sid, match.live_arena_id, match.live_arena_hidden, true);
            }, iconSummary) : html(_t20 || (_t20 = _`<td class="results-table__button-more-container"></td>`)));
          }));
        }
      }
      table = html(_t21 || (_t21 = _`<table class="results-table">${0}</table>`), tableRows);
      return table;
    }
  }, {
    key: "_renderHighlight",
    value: function _renderHighlight(highlight, class2add) {
      var _this4 = this;
      var out = [];
      var hlslug = '/resultats';
      if (this.language == 'en') hlslug = '/results';
      if (this.language == 'lu') hlslug = '/' + highlight.slug + '/resultater';
      out.push(html(_t22 || (_t22 = _`
            <div class="rtl-sport-hls-container js-hls-${0} ${0}">
                ${0}

                <div class="rtl-sport-hls__partner">
                    <div class="ad-slot ad-slot--table-sponsor">
                        <div class="ad-slot__table-sponsor">
                            <div id="table-sponsor-highlight-${0}" class="js-ad"></div>
                        </div>
                    </div>
                </div>
            </div>
        `), highlight.id, class2add, highlight.competitions.map(function (competition, key) {
        var isOpened = _this4.openFirstBox ? key == 0 : openedCompetitions.includes(competition.id);
        return html(_t23 || (_t23 = _`
                    <div class="rtl-sport-hls-competition">
                        <div class="rtl-sport-hls-competition__title" @click=${0} style="background-image: url('${0}');">${0}</div>
                        <div class="rtl-sport-hls-competition__container rtl-sport-hls-competition__container--${0}-${0} ${0}">
                        ${0}
                        <a @click=${0} class="rtl-sport-hls__more">${0} →<a>
                        </div>
                    </div>
                `), function (e) {
          return _this4._showCompetition(e, key, highlight.id);
        }, ArrowDownIcon, competition.name, highlight.id, key, isOpened ? ` rtl-sport-hls-competition__container--open` : ``, competition.rounds.map(function (round) {
          return html(_t24 || (_t24 = _`
                            <div class="rtl-sport-hls-round">
                                <div class="rtl-sport-hls-round__title">${0}</div>
                                ${0}
                            </div>
                        `), round.round == parseInt(round.round, 10) ? html(_t25 || (_t25 = _`${0}. ${0}`), round.round, _this4._getTranslation('round')) : html(_t26 || (_t26 = _`${0}`), round.round), _this4._renderMatches(round.matches, competition.id, highlight.id));
        }), function (e) {
          return _this4._showResultsAndTable(e, '/sport' + hlslug + '/national?c=' + competition.id);
        }, _this4._getTranslation('results_link'));
      }), this.types[highlight.id - 1]));
      return out;
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      var _this5 = this;
      var highlights = this.data.highlight ? this.data.highlight : [];
      var tabItems = [];
      var tabs;
      var competitions = [];
      var class2add = "";
      var i = 0;
      //console.log(highlights);
      var _loop = function _loop(key) {
        if (highlights.hasOwnProperty(key)) {
          var active = i == 0 ? 'rtl-sport-hls-nav__item--active' : '';
          tabItems.push(html(_t30 || (_t30 = _`
                    <li><img class="rtl-sport-hls-nav__item ${0}" src="${0}" alt="${0}"  @click=${0} /></li>
                `), active, SportIcons[highlights[key].id], highlights[key].name, function (e) {
            return _this5._showHighlight(e, highlights[key].id);
          }));
          class2add = i == 0 ? 'rtl-sport-hls-container--visible' : '';
          competitions.push(_this5._renderHighlight(highlights[key], class2add));
          i = i + 1;
        }
      };
      for (var key in highlights) {
        _loop(key);
      }
      tabs = html(_t27 || (_t27 = _`<ul class="rtl-sport-hls-nav">${0}</ul>`), tabItems);
      if (highlights.length > 0) {
        return html(_t28 || (_t28 = _`
                <div class="rtl-sport-hls rtl-sport-hls--${0}">

                    <div class="rtl-sport-hls__head">
                        <div class="rtl-sport-hls__logo">
                            <a href="/sport/live-arena"><img src="${0}" alt="RTL Sport Live Arena" width="145" /></a>
                        </div>
                    </div>

                    <div class="rtl-sport-hls__content">
                        <div class="rtl-sport-hls__header">
                            ${0}
                        </div>

                        <div class="js-competitions">
                            ${0}
                        </div>
                    </div>
                </div>
            `), this.type, LogoWidgetImage, tabs ? tabs : '', competitions ? competitions : '');
      } else {
        return html(_t29 || (_t29 = _``));
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t31 || (_t31 = _``));
      return html(_t32 || (_t32 = _`
            <style>${0}</style>

            ${0}
        `), css, this._renderDefault());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        aparttvMatches: {
          type: Array
        },
        data: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        weekend: {
          type: Boolean
        },
        links: {
          type: String
        }
      };
    }
  }]);
  return RTLSportHighlights;
}(LitElement);
export { RTLSportHighlights as default };
window.customElements.define('rtl-sport-highlights', RTLSportHighlights);